import database from '@/utils/database'

export default class {
  constructor (data) {
    Object.keys(data).forEach((key) => {
      this[key] = data[key]
    })
  }

  get categories () {
    if (this.itemCategoryHashes) {
      return this.itemCategoryHashes.map(cat => database.getCategory(cat))
    }
  }
}



// WEBPACK FOOTER //
// ./src/domain/Socket.js